import { render, staticRenderFns } from "./fcsd_pls.vue?vue&type=template&id=54a88a1c&scoped=true"
import script from "./fcsd_pls.vue?vue&type=script&lang=js"
export * from "./fcsd_pls.vue?vue&type=script&lang=js"
import style0 from "./fcsd_pls.vue?vue&type=style&index=0&id=54a88a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a88a1c",
  null
  
)

export default component.exports